var _classCallCheck = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var safeStringify = require('fast-safe-stringify');

/**
 * @class JsonRpcError
 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors
 * per EIP 1474.
 * Permits any integer error code.
 */
var EthereumRpcError = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(EthereumRpcError, _Error);
  /**
   * Create an Ethereum JSON RPC error.
   *
   * @param {number} code - The integer error code.
   * @param {string} message - The string message.
   * @param {any} [data] - The error data.
   */
  function EthereumRpcError(code, message, data) {
    var _this;
    _classCallCheck(this, EthereumRpcError);
    if (!Number.isInteger(code)) {
      throw new Error('"code" must be an integer.');
    }
    if (!message || typeof message !== 'string') {
      throw new Error('"message" must be a nonempty string.');
    }
    _this = _possibleConstructorReturn(this, _getPrototypeOf(EthereumRpcError).call(this, message));
    _this.code = code;
    if (data !== undefined) {
      _this.data = data;
    }
    return _this;
  }

  /**
   * Returns a plain object with all public class properties.
   *
   * @returns {object} The serialized error.
   */
  _createClass(EthereumRpcError, [{
    key: "serialize",
    value: function serialize() {
      var serialized = {
        code: this.code,
        message: this.message
      };
      if (this.data !== undefined) {
        serialized.data = this.data;
      }
      if (this.stack) {
        serialized.stack = this.stack;
      }
      return serialized;
    }
    /**
     * Return a string representation of the serialized error, omitting
     * any circular references.
     *
     * @returns {string} The serialized error as a string.
     */
  }, {
    key: "toString",
    value: function toString() {
      return safeStringify(this.serialize(), stringifyReplacer, 2);
    }
  }]);
  return EthereumRpcError;
}(_wrapNativeSuper(Error));
/**
 * @class EthereumRpcError
 * Error subclass implementing Ethereum Provider errors per EIP 1193.
 * Permits integer error codes in the [ 1000 <= 4999 ] range.
 */
var EthereumProviderError = /*#__PURE__*/function (_EthereumRpcError) {
  "use strict";

  _inherits(EthereumProviderError, _EthereumRpcError);
  /**
   * Create an Ethereum JSON RPC error.
   *
   * @param {number} code - The integer error code, in the [ 1000 <= 4999 ] range.
   * @param {string} message - The string message.
   * @param {any} [data] - The error data.
   */
  function EthereumProviderError(code, message, data) {
    _classCallCheck(this, EthereumProviderError);
    if (!isValidEthProviderCode(code)) {
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    }
    return _possibleConstructorReturn(this, _getPrototypeOf(EthereumProviderError).call(this, code, message, data));
  }
  return EthereumProviderError;
}(EthereumRpcError); // Internal
function isValidEthProviderCode(code) {
  return Number.isInteger(code) && code >= 1000 && code <= 4999;
}
function stringifyReplacer(_, value) {
  if (value === '[Circular]') {
    return undefined;
  }
  return value;
}

// Exports

module.exports = {
  EthereumRpcError: EthereumRpcError,
  EthereumProviderError: EthereumProviderError
};